var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListingDeleteImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#F46A6A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03324 15.2C7.03324 15.5006 7.15264 15.7888 7.36518 16.0014C7.57772 16.2139 7.86599 16.3333 8.16657 16.3333H13.8332C14.1338 16.3333 14.4221 16.2139 14.6346 16.0014C14.8472 15.7888 14.9666 15.5006 14.9666 15.2V8.4H16.0999V7.26667H13.8332V6.13333C13.8332 5.83275 13.7138 5.54449 13.5013 5.33195C13.2887 5.1194 13.0005 5 12.6999 5H9.2999C8.99932 5 8.71106 5.1194 8.49851 5.33195C8.28597 5.54449 8.16657 5.83275 8.16657 6.13333V7.26667H5.8999V8.4H7.03324V15.2ZM9.2999 6.13333H12.6999V7.26667H9.2999V6.13333ZM8.73324 8.4H13.8332V15.2H8.16657V8.4H8.73324Z",
    fill: "#F46A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 9.5332H10.4331V14.0665H9.2998V9.5332ZM11.5665 9.5332H12.6998V14.0665H11.5665V9.5332Z",
    fill: "#F46A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_2091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingDeleteImage);
export default __webpack_public_path__ + "static/media/listing-delete-image.4e412fa4432aafbe77b113219f7fad2c.svg";
export { ForwardRef as ReactComponent };